import React from 'react'
import * as R from 'ramda'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Trash2, X } from 'lucide-react'
import AttachmentImage from './attachmentImage'
import { DeleteOutlinedIcon } from 'app/components/icons'

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
    },
  },
  dialogTitle: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.grey[100],
  },
  dialogContent: {
    padding: theme.spacing(2, 3),
    paddingBottom: theme.spacing(4),
  },
}))

export default function ImageGalleryDialog({
  open,
  onClose,
  images,
  onSelectImage,
  onDeleteImage,
  onDeleteAll,
  title,
  loadedCount,
  loadingCount,
}) {
  const classes = useStyles()

  const { formatMessage } = useIntl()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle className={classes.dialogTitle}>
        <div className="flex flex-col sm:flex-row flex-wrap sm:justify-between sm:items-center gap-3 sm:gap-4 text-primary">
          <div className="flex items-center gap-2 flex-shrink-0 text-primary-400">
            <span className="text-16 sm:text-17 md:text-18 font-medium">
              {title || (
                <FormattedMessage id="compose.dialog.attachments.label" />
              )}
            </span>
            <span className="text-14 sm:text-15 md:text-16 whitespace-nowrap">
              {`(${loadedCount})`}
              {loadingCount > 0 && (
                <span className="ml-2 text-primary/70">
                  {loadingCount}{' '}
                  {formatMessage({
                    id: 'compose.dialog.attachments.uploading',
                  })}
                  {'...'}
                </span>
              )}
            </span>
          </div>

          <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-end">
            {onDeleteAll && images?.length > 0 && !loadingCount > 0 && (
              <button
                onClick={onDeleteAll}
                className="border border-red rounded-[6px] py-[4px] px-[16px] rounded-5 bg-white  text-[14px] text-red hover:bg-red/10 flex items-center gap-2 transition-colors"
              >
                <div className="hidden sm:inline whitespace-nowrap">
                  {formatMessage({
                    id: 'compose.dialog.attachments.deleteAll.buttonLabel',
                  })}
                </div>
                <DeleteOutlinedIcon className="w-[12px] h-[12px]" />
              </button>
            )}

            <IconButton
              onClick={onClose}
              size="small"
              className="flex-shrink-0"
            >
              <X className="w-7 h-7" />
            </IconButton>
          </div>
        </div>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 md:gap-6 py-2 sm:py-4">
          {images?.map((image, index) => {
            const imageKey =
              R.prop('id', image) || R.prop('uploadId', image) || index
            return (
              <AttachmentImage
                key={`image-${index}-${imageKey}`}
                image={image}
                handleDeleteImage={onDeleteImage}
                handleSelectImage={onSelectImage}
                className="w-[90%]"
              />
            )
          })}
        </div>
      </DialogContent>
    </Dialog>
  )
}
